export function checkAndSendCommentMails(comment, postId, tmpCommunityType) {
    $.ajax({
        type: "POST",
        url: "/module/community/ajax.php?action=check_and_send_comment_mails",
        datatype: "json",
        data: {
            "ajax_call_shop_user_id": shopUserId,
            "ajax_call_community_type": tmpCommunityType,
            "ajax_call_comment": comment,
            "ajax_call_post_id": postId,
            "ajax_call_main_language_id": mainLanguageId,
            "ajax_call_main_language_code": mainLanguageCode,
            "ajax_call_site_code": siteCode
        }
    });
}